/**
 * Add whitelabel theme to cookie manager root element
 */
export const useCookieManager = () => {
  const addWhiteLabelThemeClass = (ccmWidget: Element | null) => {
    if (!ccmWidget) {
      return;
    }
    ccmWidget.classList.add('theme-monochrome');
  };

  const addImprintAndPrivacyLinks = (
    linkContainer: Element | null,
    imprint: string,
    privacy: string
  ) => {
    if (!linkContainer) {
      return;
    }

    // We need to loop through the HTMLCollection as we cannot get the links directly as they do not have any ids/classes
    for (let i = 0; i < linkContainer.children.length; i++) {
      const link = linkContainer.children[i] as HTMLAnchorElement;

      if (link.textContent?.toLowerCase().match('impressum')) {
        link.href = imprint;
      }

      if (link.textContent?.toLowerCase().match('datenschutzhinweis')) {
        link.href = privacy;
      }
    }
  };

  return {
    addWhiteLabelThemeClass,
    addImprintAndPrivacyLinks,
  };
};
